import { actionTypes } from './sticky-book-banner-actions';
import { ContentState } from 'modules/brochureware/brochureware-types';

const initialState = {
  content: {},
  error: {},
};

export default (state = initialState, action: any): ContentState => {
  switch (action.type) {
    case actionTypes.FETCH_STICKY_BOOK_BANNER_CONTENT_SUCCESS: {
      return {
        ...state,
        content: { ...action.payload.content },
      };
    }
    case actionTypes.FETCH_STICKY_BOOK_BANNER_CONTENT_FAILURE: {
      return {
        ...state,
        error: { ...action.payload.error },
      };
    }

    default:
      return state;
  }
};
